import { Box, Spinner } from '@chakra-ui/react';
import { TextMedium } from 'UiKit/typography';
import useIsMobile from 'Hook/useIsMobile';

import styles from './styles.module.css';

const LoaderPrimary = () => {
  const isMobile = useIsMobile();

  const spinnerSize = isMobile ? '36px' : '48px';

  return (
    <Box className={styles['loader__container']}>
      <Box className={styles['overlay']} />
      <Box className={styles['loader__box']}>
        <Spinner borderWidth="3px" width={spinnerSize} height={spinnerSize} color="var(--color-primary)" mb="16px" />
        <TextMedium className={styles['loader__text']}>Loading</TextMedium>
      </Box>
    </Box>
  );
};

export default LoaderPrimary;
